export default "__VITE_ASSET__CKFOjg9c__"